export default __webpack_public_path__ + "static/media/arrow-right.202dbc0c.svg";